import { Component, EventEmitter, OnInit, Output, HostListener, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpClientModule, HttpHeaders, } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApidataService } from '../apidata.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';

@Component({
  selector: 'app-language',
  standalone: true,
  imports: [NgbDatepickerModule, HttpClientModule, CommonModule,
    ReactiveFormsModule,
    FormsModule, 
  ],
  templateUrl: './language.component.html',
  styleUrl: './language.component.css'
})
export class LanguageComponent {

  closeResult = '';
  labguageFileText;
  checklanguageus;
  checklanguageusa;
  checklanguage;
  uklanguage;
  doneuk;
  doneus;
  checkeduk: boolean = false;
  checkedus: boolean = false;
  uk = "uk";
  profile_id = "";
  savelanguage: Boolean = false;
  showAll: boolean = false;


  constructor(private modalService: NgbModal,
    private router: Router,
    private apiservice: ApidataService,
    private http: HttpClient,
    private elementRef: ElementRef,) { }
  @ViewChild('content', { static: true }) content: TemplateRef<any>;

  ngOnInit() {
    this.openModal();
    const savedLanguage = localStorage.getItem('selectedLanguage');

    if (savedLanguage) {
      this.selectedLanguage = JSON.parse(savedLanguage);  
    } else {
      this.selectedLanguage = this.languages[0]; 
    }

  }
  openModal() {
    this.modalService.open(this.content, { backdrop: 'static', keyboard: false, centered: true, windowClass: 'my-class' });
  }

  openModels(content: any, data: any = null) {
    this.modalService.open(content, { size: "lg" })
  }




  @HostListener('document:click', ['$event'])
  closeMenuOnOutsideClick(event: Event) {
    const clickedElement = event.target as HTMLElement;
    if (!this.elementRef.nativeElement.contains(clickedElement) && !clickedElement.classList.contains('menu-btn')) {
      this.isMenuOpen = false;
    }
  }


  languages = [
    { name: 'English Us', icon: '/assets/images/plagiarism checker1/language.svg', code: 'en-us' },
    { name: 'English UK', icon: '/assets/images/flag/British.svg', code: 'en-gb' },
    { name: 'English CAN', icon: '/assets/images/flag/Canadian.svg', code: 'en-ca' },
    { name: 'English AUS', icon: '/assets/images/flag/Australian.svg', code: 'en-au' },
    { name: 'English IND', icon: '/assets/images/flag/india.svg', code: 'en-in' },
    { name: 'German', icon: '/assets/images/flag/german.svg', code: 'de' },
  ];
  selectedLanguage = this.languages[0]; 


  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }



  get filteredLanguages() {
    return this.languages.filter(lang => lang.code !== this.selectedLanguage.code);
  }




  userPrefLanguage = '';
  isMenuOpen = false;
  isLanguageUpdating = false;
  modalElement: any;
  selectLanguage(language) {
    this.selectedLanguage = language;
    localStorage.setItem('selectedLanguage', JSON.stringify(this.selectedLanguage));
    this.updatePreferredLanguage(language.code);
  }
  isEnglishVariantSelected(): boolean {
    return ['English Us', 'English UK'].includes(this.selectedLanguage.name);
  }


  updatePreferredLanguage(pref_language: string) {
    const profile_id = localStorage.getItem("profile_id"); 
    this.isLanguageUpdating = true;  

    if (profile_id) {
      this.apiservice.updateUserLanguage(profile_id, pref_language).subscribe(
        (response) => {
          this.handleLangChange(response);
          this.isLanguageUpdating = false;
        },
        (error) => {
      
          this.isLanguageUpdating = false;
        }
      );
    } else {
 
      this.isLanguageUpdating = false;
    }
  }


  handleLangChange(response: Response) {
    this.userPrefLanguage = response['contents'];
    this.showSuccessMessage("Language updated successfully!");
  }

  showSuccessMessage(message: string) {
    this.labguageFileText = message;
    document.getElementById("labguageFileText").style.display = 'block';
    setTimeout(() => {
      document.getElementById("labguageFileText").style.display = 'none';

    }, 3000);
  }
  closeModal() {
    if (!this.isLanguageUpdating) {  
      this.modalService.dismissAll(); 
    }
  }

}



